module.exports = __webpack_public_path__ + "static/media/mariadb.2a77047c.svg";